import { FC } from 'react';
import { RiLoader2Line } from '@remixicon/react';
import styles from './LoadingWheel.module.css';

interface LoadingWheelProps {
  size: number;
  className?: string; // Optional className prop for additional styling
}

const LoadingWheel: FC<LoadingWheelProps> = ({ size, className }) => {
  // Combine provided className with the default style
  const combinedClassName = `${styles.loading__icon} ${className || ''}`.trim();

  return <RiLoader2Line size={size} className={combinedClassName} />;
};

export default LoadingWheel;
